import script from "./ChatSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=27f06f4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f06f4d"]])

export default __exports__